<!-- begin:: Content Head -->
<div class="kt-subheader kt-grid__item" [hidden]="subheaderService.disabled$ | async" id="kt_subheader" [style.display]="(isGISView && isDashboardPage) || enableFullPage || hideSubHeader ? 'none' : 'flex'">
	<div class="kt-subheader__main" *ngIf="!facilitySelector">
		<h3 *ngIf="title" [ngClass]="{ 'mobile-class': mobileView }" class="kt-subheader__title">{{title}}</h3>
		<!-- <span class="kt-subheader__separator kt-subheader__separator--v"></span> -->
		<span *ngIf="desc" class="kt-subheader__desc">{{desc}}</span>
		<!-- <a href="javascript:;" class="btn btn-label-primary btn-bold btn-icon-h">
			Add New
		</a> -->
	</div>
	<ng-container *ngIf="!isCommercialized && !isGISView">
		<div class="kt-subheader__main" *ngIf="facilitySelector">
			<mat-form-field>
				<mat-select disableOptionCentering="true" #mySelect placeholder="Select" [formControl]="selectedFacilityList"
					(selectionChange)="onFacilityChange($event)">
					<ng-container *ngFor="let f of facilityList;">
						<mat-option [value]="f._id" (click)="onClick(f._id)" [matTooltip]="f.name">
							{{f.name}}
						</mat-option>
						<div class="d-flex flex-column option-checkbox">
							<mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
								[value]="f.activePlant" (change)="onPlantChange($event, f._id)">
								<mat-radio-button class="example-radio-button" *ngFor="let p of f.units;" [value]="p._id">
									{{p.name}}
								</mat-radio-button>
							</mat-radio-group>
						</div>
						<mat-divider></mat-divider>
					</ng-container>
				</mat-select>
			</mat-form-field>&nbsp;&nbsp;
			<!-- <ng-container *ngIf="unitValue.value">
									<mat-form-field>
										<input matInput placeholder="Unit" [formControl]="unitValue" [value]="unitValue.value" readonly>
									</mat-form-field>
								</ng-container> -->
		</div>
	<div style="display: flex; flex-direction: row;">
		<button mat-stroked-button color="primary" (click)="renderOnDashboard()" *ngIf="!isGISView && isDashboardPage && dashboard == 'renewables-dashboard'" style=" height: 40px;">Back to GIS View</button>
		<div *ngIf="isDashboardPage && hasAccessToDGR && !isGISView && dashboard == 'renewables-dashboard'" style="margin-left: 10px;">
			<mat-form-field>
				<mat-label>Choose a date</mat-label>
				<input [max]="todayDate" matInput [matDatepicker]="picker" (click)="picker.open()" readonly
					(dateInput)="dgpDatePicked($event)">
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>&nbsp;
			<button mat-stroked-button color="primary" (click)="downloadDGR($event)">Download DGR</button>
		</div>
	</div>

	</ng-container>
	<ng-container *ngIf="isCommercialized && !isGISView">
		<div class="kt-subheader__main facility-unit-selectors" *ngIf="facilitySelector">
			<!-- for facility start -->
			<div class="facility-unit-field">
				<kt-select label="Facility" [options]="facilityOptions" [formControl]="selectedFacilityList" labelPosition="left"
					(selectionChange)="onFacilityChange({ value: $event })"></kt-select>
			</div>
			<!-- for facility end -->
			<!-- for unit start -->
			<div class="facility-unit-field"
				*ngIf="dashboard != 'energy-dashboard' && dashboard != 'pdo-dashboard' && dashboard != 'renewables-dashboard'">
				<kt-select label="Unit" [options]="unitOptions" [formControl]="unitValue" labelPosition="left"
					(selectionChange)="onPlantChange({ value: $event }, selectedFacilityList.value)"></kt-select>
			</div>
			<!-- for unit end -->
		</div>
		<div>
			<div style="display: flex; flex-direction: row;">
				<button mat-stroked-button color="primary" (click)="renderOnDashboard()" *ngIf="!isGISView && isDashboardPage && dashboard == 'renewables-dashboard'">Back to GIS View</button>

				<div *ngIf="isDashboardPage && hasAccessToDGR && !isGISView && dashboard == 'renewables-dashboard'" style="margin-left: 10px;">
					<!-- <mat-form-field>
								<mat-label>Choose a date</mat-label>
								<input [max]="todayDate" matInput [matDatepicker]="picker" (click)="picker.open()" readonly
									(dateInput)="dgpDatePicked($event)">
								<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
								<mat-datepicker #picker></mat-datepicker>
							</mat-form-field>&nbsp; -->
					<button mat-stroked-button color="primary" (click)="downloadDGR($event)">Download DGR</button>
				</div>
			</div>
		</div>
	</ng-container>
	<div class="kt-subheader__toolbar" *ngIf="!hideTimeWindow">
		<div class="kt-subheader__wrapper">
			<button mat-button *ngIf="showPageSwitcher" class="page-switcher"
				[disableRipple]="true" (click)="switchToAlertsV2Page()">
				<img class="page-switcher__icon" src="assets/media/icons/new.svg" alt="New">
				<span class="page-switcher__label">Switch to New Alert View</span>
			</button>
			<div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline" data-placement="left">
				<a ngbDropdownToggle href="javascript:;" class="btn kt-subheader__btn-daterange"
					id="kt_dashboard_daterangepicker" data-placement="left" ngbTooltip="Select Date Range">
					<span class="kt-subheader__btn-daterange-title"
						id="kt_dashboard_daterangepicker_title">{{currentTimeSelected.name}}</span>&nbsp;
					<span class="kt-subheader__btn-daterange-date"
						id="kt_dashboard_daterangepicker_date"></span>
					<span class="material-symbols-outlined subheader-calendar-icon">calendar_today</span>
				</a>
				<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
					<a *ngFor="let t of timeWindow;" (click)="onRangeSelection(t)" class="dropdown-item">{{t.name}}</a>
				</div>
			</div>

			<!-- <a href="javascript:;" class="btn kt-subheader__btn-primary btn-icon">
				<i class="flaticon2-file"></i>
			</a>

			<a href="javascript:;" class="btn kt-subheader__btn-primary btn-icon">
				<i class="flaticon-download-1"></i>
			</a>

			<a href="javascript:;" class="btn kt-subheader__btn-primary btn-icon">
				<i class="flaticon2-fax"></i>
			</a>

			<a href="javascript:;" class="btn kt-subheader__btn-primary btn-icon">
				<i class="flaticon2-settings"></i>
			</a> -->

			<!-- <div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline" data-placement="left"
				ngbTooltip="Quick actions">
				<a ngbDropdownToggle href="javascript:;" class="btn btn-brand btn-icon">
					<i class="flaticon2-plus"></i>
				</a>
				<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
					<a class="dropdown-item" href="javascript:;"><i class="la la-plus"></i> New Report</a>
					<a class="dropdown-item" href="javascript:;"><i class="la la-user"></i> Add Customer</a>
					<a class="dropdown-item" href="javascript:;"><i class="la la-cloud-download"></i> New Download</a>
					<div class="dropdown-divider"></div>
					<a class="dropdown-item" href="javascript:;"><i class="la la-cog"></i> Settings</a>
				</div>
			</div> -->
		</div>
	</div>
</div>
<!-- end:: Content Head -->